import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { blogSlugFromPath, loadBlogPost } from "@/blog/data";
import i18n from "@/i18n";
import { Root } from "./Root";
import "./index.css";

declare global {
  interface Window {
    __lucentiaBooted?: boolean;
  }
}

const container = document.getElementById("root")!;
const tree = (
  <StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </StrictMode>
);

function boot() {
  /* Pages are prerendered in Spanish. Hydrate them as-is; a visitor who chose
     English gets a fresh client render instead of a mismatched hydration. */
  if (container.hasChildNodes() && i18n.language === "es") {
    hydrateRoot(container, tree);
  } else {
    container.replaceChildren();
    createRoot(container).render(tree);
  }
  window.__lucentiaBooted = true;
}

/* An article's body is its own chunk: fetch it first so hydration sees the
   same content the prerendered HTML already shows. */
const slug = blogSlugFromPath(window.location.pathname);
if (slug) {
  loadBlogPost(slug).catch(() => null).finally(boot);
} else {
  boot();
}
